<svelte:options accessors/>
<script>
    import NauiSteps from "../../../naui/molecules/NauiSteps.svelte";
    import ReportarVehiculo1 from "./steps/ReportarVehiculo1.svelte";
    import ReportarVehiculo2 from "./steps/ReportarVehiculo2.svelte";
    import ReportarVehiculo3 from "./steps/ReportarVehiculo3.svelte";
    import ReportarVehiculo4 from "./steps/ReportarVehiculo4.svelte";

    export let parametros_step_1;
    export let parametros_step_2;
    export let parametros_step_3;

    let steps = [
        'Paso 1', 'Paso 2', 'Paso 3', 'Paso 4'
    ]
    let step = 0;

    function next() {
        step = step + 1;
        document.getElementById('marker').scrollIntoView(true);

    }

    function prev() {
        step = step - 1;
        document.getElementById('marker').scrollIntoView(true);
    }

    function submit() {

    }

</script>
<section>
    <div id="steps">
        <NauiSteps {steps} {step} color="#00B1B7"/>
    </div>
    <div class="py-15">
        {#if step === 0}
            <ReportarVehiculo1 {parametros_step_1} on:click={next}/>
        {:else if step === 1}
            <ReportarVehiculo2 {parametros_step_2} on:next={next} on:prev={prev}/>
        {:else if step === 2}
            <ReportarVehiculo3 {parametros_step_3} on:next={next} on:prev={prev}/>
        {:else if step === 3}
            <ReportarVehiculo4 on:submit={submit} on:prev={prev}/>
        {/if}
    </div>

</section>